import React, { useCallback, useEffect, useRef, useState } from 'react'
import { DatePicker, Divider, Radio, Spin, notification, Typography } from "antd";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, debounce, isEmpty, isEqual } from 'lodash';
import dayjs from "dayjs";
import moment from 'moment';
import { useParams } from 'react-router-dom';

import ReactSelect from '../../../../../../components/uiComponent/select';
import Button from "../../../../../../components/uiComponent/button/index";
import Input from "../../../../../../components/uiComponent/inputs/input/index"
import Modal from "../../../../../../components/uiComponent/modal";
import PackScanModal from './PackScanModal';

import { StepThreeWrapper, ContactInformationWrapper, AlertModalStyleWrapper } from '../style';
import { InputWrapper } from "../../../../../../components/uiComponent/inputs/style";
import {
  ListTransportationOptions,
  ListDeliveryWindowOptions,
  ConfirmTransportationOptions,
  ConfirmDeliveryWindowOption,
  UpdateShipmentTrackingDetails,
  GetWarehouseShipments,
  SaveTransportationDetails,
  ListPlacementOptions,
  ConfirmPlacementOption,
  GenerateTransportationOptions,
  GenerateDeliveryWindowOptions,
  CreatePallets,
  clearTransportationOptions,
  GetShipmentBoxes
} from '../../../../../../slices/post-shipment';
import { sellerFreightClassValues } from '../../../../../fbaInbound/constants';
import PlacementCard from '../../../../../../components/uiComponent/placement-card';
import AgGrid from '../../../../../../components/ag-grid-table/index';
import ProductImg from '../../../../../../assets/images/newImages/nestle.svg';
import DeleteIcon from '../../../../../../assets/icons/delete-border-icon.svg';
import AlterIcon1 from '../../../../../../assets/icons/AlertIcon1.svg';
import useResponsiveTableHeight from '../../../../../../hooks/useResponsiveTableHeight';

const StepThree = ({
  showTransportGlobal,
  setActiveKey,
  shipmentIdOuter,
  setTransportationDetails,
  transportationDetails,
  updateShipmentTrackingDetailsLoading,
  deliveryWindowOptionsLoading,
  generatingTransportationOptions,
  generatingDeliveryWindowOptions,
  onCancelPlan,
  cancelingInboundPlan,
}) => {
  const dispatch = useDispatch();
  const { workOrderId } = useParams();

  // const [deliveryWindowOptionsLoading, setDeliveryWindowOptionsLoading] = useState(false);
  // const [updateShipmentTrackingDetailsLoading, setUpdateShipmentTrackingDetailsLoading] = useState(false);
  const [selectedPCOptions, setSelectedPCOptions] = useState([])
  const [partneredCarrierValue, setPartneredCarrierValue] = useState([])
  const [pickupDate, setPickupDate] = useState([]);
  const [selectedPlacementIndex, setSelectedPlacementIndex] = useState(0);
  const [selectedShipmentIndex, setSelectedShipmentIndex] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);

  const { tableHeight, tableSectionRef } = useResponsiveTableHeight({
    minHeight: 220,
    bottomSpacing: 24,
    observeSelectors: ['.content-area-wrapper .tabs-cards-wrapper']
  });

  const {
    shipmentDetails,
    fetchingWarehouseShipments,
    transportationOptions,
    listingTransportationOptions,
    deliveryWindowOptions,
    listingDeliveryWindowOptions,
    confirmingDeliveryWindowOption,
    confirmingTransportationOption,
    updatingShipmentTrackingDetails,
    saveTransportationDetailsLoading,
    placementOptions,
    listingPlacementOptions,
    confirmingPlacementOption,
    generatingTransportationOptions: generatingTransportationOptionsLoading,
    generatingDeliveryWindowOptions: generatingDeliveryWindowOptionsLoading,
    shipmentType
  } = useSelector((state) => state.postShipment || {});
  const { currentUser } = useSelector((state) => state.auth || {});
  // const [transportationDetails, setTransportationDetails] = useState([]);
  const [triggerAutosave, setTriggerAutosave] = useState(false);
  const [isResetModalVisible, setIsResetModalVisible] = useState(false);
  const [resetCallback, setResetCallback] = useState(null);
  const [shipmentBoxes, setShipmentBoxes] = useState({});
  const [packScanVisible, setPackScanVisible] = useState(false);

  const confirmReset = (callback) => {
    if (!hasNoOptions) {
      setIsResetModalVisible(true);
      setResetCallback(() => callback);
    } else {
      callback();
    }
  };

  const handleResetConfirm = () => {
    dispatch(clearTransportationOptions());
    if (resetCallback) resetCallback();
    setIsResetModalVisible(false);
    setResetCallback(null);
  };

  useEffect(() => {
    setSelectedPlacementIndex(0);
    setSelectedShipmentIndex(0);
  }, [placementOptions?.length]);

  const { amazonInboundPlanId: inboundPlanId, shipments, contactDetails: initialContactDetails, placementFee, packingMethod } = shipmentDetails || {};
  const [contactDetails, setContactDetails] = useState(initialContactDetails || { name: '', phone: '', email: '', shipDate: '' });
  const [shipmentsData, setShipmentsData] = useState([]);
  const [deletedPallets, setDeletedPallets] = useState([]);
  const isPackNow = packingMethod === 'pack_now';
  const getShipmentMode = (detail = {}) => {
    if (!isPackNow) return 'LTL';
    const raw = detail.shipmentType || detail.shipment_type || shipmentType || 'SP';
    if (raw === 'GROUND_SMALL_PARCEL' || raw === 'SPD') return 'SP';
    if (raw === 'LESS_THAN_TRUCKLOAD') return 'LTL';
    return raw;
  };
  const isSpShipment = (detail = {}) => getShipmentMode(detail) === 'SP';
  const hasLtlShipment = () => transportationDetails.some(detail => !isSpShipment(detail));

  useEffect(() => {
    if (initialContactDetails) {
      setContactDetails(prev => ({
        ...prev,
        ...initialContactDetails,
        phone: initialContactDetails.phone || initialContactDetails.phone_number || prev.phone || '',
        shipDate: initialContactDetails.shipDate || initialContactDetails.ship_date || prev.shipDate || ''
      }));
    }
  }, [JSON.stringify(initialContactDetails)]);

  // Initialize per-shipment pallet/freight state from Redux shipments
  useEffect(() => {
    if (!shipments?.length || shipmentsData.length > 0) return;
    setShipmentsData(shipments.map(s => ({
      amazon_shipment_id: s.amazon_shipment_id,
      amazon_shipment_confirmation_id: s.amazon_shipment_confirmation_id,
      amazon_warehouse_id: s.amazon_warehouse_id,
      freightInfo: {
        value: s.freight_value || '',
        class: s.freight_class || ''
      },
      pallets: s.pallets?.length ? s.pallets.map(p => ({
        id: p.id,
        height: p.height,
        width: p.width || 48,
        length: p.length || 40,
        weight: p.weight,
        stackable: p.is_stacked === true ? 'Yes' : 'No',
        noOfPallets: p.no_of_pallets || 1
      })) : [{ length: 40, width: 48, height: '', weight: '', stackable: 'No', noOfPallets: 1 }]
    })));
  }, [shipments]);

  useEffect(() => {
    if (!shipments?.length) return;
    setTransportationDetails(prev => shipments.map((shipment, index) => {
      const existing = (prev || []).find(detail => detail.shipmentId === shipment.amazon_shipment_id)
        || shipmentDetails?.transportationDetails?.find?.(detail => detail.shipmentId === shipment.amazon_shipment_id)
        || prev?.[index]
        || {};

      return {
        shipmentId: shipment.amazon_shipment_id,
        carrierType: existing.carrierType || existing.carrier_type || 'partnered',
        shipmentType: getShipmentMode(existing),
        transportationOptionId: existing.transportationOptionId || {
          partnered: existing.partneredId || existing.partnered_id || '',
          nonPartnered: existing.nonPartneredId || existing.non_partnered_id || ''
        },
        deliveryWindowOptionId: existing.deliveryWindowOptionId || existing.delivery_window_option_id || '',
        proNumber: existing.proNumber || existing.pro_number || '',
        spdTrackingItems: existing.spdTrackingItems || {}
      };
    }));
  // Intentionally excludes `shipmentType` — re-running when global type changes would reset
  // per-shipment user selections made via the SPD/LTL radio buttons in pack_now flow.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipments?.map(({ amazon_shipment_id }) => amazon_shipment_id).join(',')]);

  const calculateFreightClass = (pallets) => {
    const getClass = (density) => {
      if (density > 50) return 50; if (density > 35) return 55; if (density > 30) return 60;
      if (density > 22.5) return 65; if (density > 15) return 70; if (density > 13.5) return 77.5;
      if (density > 12) return 85; if (density > 10.5) return 92.5; if (density > 9) return 100;
      if (density > 8) return 110; if (density > 7) return 125; if (density > 6) return 150;
      if (density > 5) return 175; if (density > 4) return 200; if (density > 3) return 250;
      if (density > 2) return 300; if (density > 1) return 400; return 500;
    };
    let highest = 0;
    pallets.forEach(({ height, weight, stackable, noOfPallets }) => {
      if (!height || !weight) return;
      const vol = (40 * 48 * Number(height)) / 1728 * (Number(noOfPallets) || 1);
      const wt = Number(weight) * (Number(noOfPallets) || 1);
      let fc = getClass(wt / vol);
      if (stackable === 'No') {
        const idx = sellerFreightClassValues.findIndex(o => o.value === Number(fc));
        fc = sellerFreightClassValues[Math.min(idx + 1, sellerFreightClassValues.length - 1)]?.value;
      }
      if (Number(fc) > highest) highest = Number(fc);
    });
    return highest;
  };

  const handlePalletUpdate = (shipmentIndex, palletIndex, key, value) => {
    confirmReset(() => {
      setShipmentsData(prev => {
        const clone = cloneDeep(prev);
        clone[shipmentIndex].pallets[palletIndex][key] = value;
        if (clone[shipmentIndex].freightInfo.class === 'estimate') {
          clone[shipmentIndex].freightInfo.estimatedClass = calculateFreightClass(clone[shipmentIndex].pallets);
        }
        return clone;
      });
    });
  };

  const handleFreightInfoUpdate = (shipmentIndex, key, value, estimatedExtraKey) => {
    confirmReset(() => {
      setShipmentsData(prev => {
        const clone = cloneDeep(prev);
        clone[shipmentIndex].freightInfo = {
          ...clone[shipmentIndex].freightInfo,
          [key]: value,
          ...(key === 'class' && estimatedExtraKey !== undefined && { tempoEstKey: estimatedExtraKey, estimatedClass: estimatedExtraKey })
        };
        return clone;
      });
    });
  };

  const addPalletRow = (shipmentIndex) => {
    confirmReset(() => {
      setShipmentsData(prev => {
        const clone = cloneDeep(prev);
        clone[shipmentIndex].pallets.unshift({ length: 40, width: 48, height: '', weight: '', stackable: 'No', noOfPallets: 1 });
        return clone;
      });
    });
  };

  const removePalletRow = (shipmentIndex, palletIndex, palletId) => {
    confirmReset(() => {
      if (palletId) setDeletedPallets(prev => [...prev, palletId]);
      setShipmentsData(prev => {
        const clone = cloneDeep(prev);
        clone[shipmentIndex].pallets.splice(palletIndex, 1);
        return clone;
      });
    });
  };

  const isPalletsComplete = () => {
    return shipmentsData.every((s, sIdx) => {
      const detail = transportationDetails.find(({ shipmentId }) => shipmentId === s.amazon_shipment_id)
        || transportationDetails[sIdx]
        || {};
      if (isSpShipment(detail)) return true;
      const hasFreight = s.freightInfo?.value && s.freightInfo?.class;
      const hasPallets = s.pallets?.length > 0 && s.pallets.every(p =>
        p.height && p.weight && p.stackable && p.noOfPallets &&
        Number(p.height) > 0 && Number(p.weight) > 0 && Number(p.noOfPallets) > 0
      );
      return hasFreight && hasPallets;
    });
  };

  const { nonPartneredOptions, partneredOptions } = transportationOptions || {};

  const selectRefs = useRef([]);
  const packNowOptionsFetchRef = useRef('');

  useEffect(() => {
    // Automatic fetching on mount removed per user request.
    // Transportation options should be generated/listed manually via the "Generate Transportation Options" button.
  }, []);

  useEffect(() => {
      if (!isPackNow) setTransportationDetails(shipmentDetails?.transportationDetails || []);
  }, [shipmentDetails]);

  useEffect(() => {
    if (packingMethod === 'pack_now' && isEmpty(shipments)) {
      dispatch(ListPlacementOptions({ workOrderId }));
    }
  }, [packingMethod, shipments]);

  useEffect(() => {
    // For Pack Later rendered inline from ShipmentPallets, skip this fetch
    // since index.js already dispatches ListTransportationOptions before navigating to Step 3.
    // Only fetch if this is a fresh page load (no transportation options in Redux yet).
    if (showTransportGlobal) return;

    dispatch(GetWarehouseShipments({
      workOrderId,
    })).then(({ payload }) => {
      if (payload?.success) {
        if (payload?.shipmentDetails?.packingMethod !== 'pack_now') {
          const { amazonInboundPlanId, shipments } = payload.shipmentDetails;
          setTransportationDetails(payload?.shipmentDetails?.transportationDetails || []);
          
          if (amazonInboundPlanId && shipments?.length > 0) {
            dispatch(ListTransportationOptions({ 
              inboundPlanId: amazonInboundPlanId, 
              placementOptionId: shipments[0]?.amazon_placement_option_id 
            }));
            const shipmentIds = shipments.map(s => s.amazon_shipment_id);
            dispatch(ListDeliveryWindowOptions({ inboundPlanId: amazonInboundPlanId, shipmentIds }));
          }
        }
      }
    });
  }, []);


  useEffect(() => {

    if (Object.keys(transportationOptions).length > 0) {

      shipments.forEach(({ amazon_shipment_id }, index) => {
        let pickupOptions = selectRefs?.current[index]?.getValue();
        if (pickupOptions && pickupOptions.length > 0) {
          setSelectedPCOptions(options => {
            const optionsClone = cloneDeep(options);
            optionsClone[index] = pickupOptions[0]?.value
            return optionsClone;
          })
        }

      })


    }
  }, [transportationOptions, shipments])




  const isGeneratingRef = useRef(false);


  const handleGenerateTransportationOptions = async (isManual = false) => {
    if (isGeneratingRef.current || generatingTransportationOptionsLoading) return;

    const { name, phone, email, shipDate } = contactDetails || {};
    if (!shipDate) {
      if (isManual) {
        notification.error({ message: 'Please select a ready to ship date' });
      }
      return;
    }
    if (!moment.utc(shipDate).startOf('day').isAfter(moment.utc().startOf('day'))) {
      if (isManual) {
        notification.error({ message: 'Ready to ship date must be a future date. Please select tomorrow or later.' });
      }
      return;
    }
    const hasLtl = hasLtlShipment();
    if (!name || !phone || !email) {
      if (isManual) {
        notification.error({ message: 'Please fill in all contact information' });
      }
      return;
    }

    // For LTL pack_now: validate that every LTL shipment has at least one pallet with height/weight filled
    if (hasLtl && packingMethod === 'pack_now' && isManual) {
      const ltlShipmentIds = transportationDetails.filter(detail => !isSpShipment(detail)).map(({ shipmentId }) => shipmentId);
      const missingPallets = shipmentsData.filter(s => ltlShipmentIds.includes(s.amazon_shipment_id)).some(s =>
        !(s.pallets || []).some(p => Number(p.height) > 0 && Number(p.weight) > 0)
      );
      if (missingPallets) {
        notification.error({ message: 'Please fill in pallet dimensions (height and weight) for all LTL shipments' });
        return;
      }
    }

    // For pack_now: save pallet/freight/contact data to DB first so the regeneration path works
    if (packingMethod === 'pack_now') {
      const ltlShipmentIds = transportationDetails.filter(detail => !isSpShipment(detail)).map(({ shipmentId }) => shipmentId);
      const mappedPallets = shipmentsData.filter(s => ltlShipmentIds.includes(s.amazon_shipment_id)).flatMap(s =>
        s.pallets.map(({ id, noOfPallets, height, width, length, weight, stackable }) => ({
          id,
          noOfPallets: Number(noOfPallets),
          height, width: width || 48, length: length || 40, weight,
          isStacked: stackable === 'Yes',
          amazonShipmentId: s.amazon_shipment_id
        }))
      );
      const shipmentsFreightInfo = shipmentsData.filter(s => ltlShipmentIds.includes(s.amazon_shipment_id)).map(s => {
        const fi = { ...s.freightInfo };
        if (fi.class === 'estimate') {
          fi.class = fi.estimatedClass?.toFixed(2)?.toString() || '';
          delete fi.estimatedClass; delete fi.tempoEstKey;
        }
        return { freightInfo: fi, amazonShipmentId: s.amazon_shipment_id };
      });
      await dispatch(CreatePallets({ 
        pallets: mappedPallets, 
        deletedPallets, 
        contactDetails: {
          ...toSnakeCase(contactDetails),
          phone_number: contactDetails.phone
        }, 
        shipmentsFreightInfo, 
        inboundPlanId 
      }));
      setDeletedPallets([]);
    }

    const formatDateForAmazon = (dateString) => {
      // Use UTC midnight to avoid timezone offset making local midnight appear as "yesterday" in UTC
      return moment.utc(dateString).startOf('day').toISOString().replace('.000', '');
    };

    const shipmentTransportationConfigurations = shipments.map((s, sIndex) => {
      const config = {
        readyToShipWindow: { start: formatDateForAmazon(shipDate) },
        shipmentId: s.amazon_shipment_id
      };
      const detail = transportationDetails.find(({ shipmentId }) => shipmentId === s.amazon_shipment_id)
        || transportationDetails[sIndex]
        || {};

      if (!isSpShipment(detail)) {
        if (name && phone && email) {
          config.contactInformation = { email, name, phoneNumber: phone };
        }
        // Match by amazon_shipment_id OR amazon_shipment_confirmation_id since pack_now
        // may use either depending on when shipments were confirmed
        const localShipment = shipmentsData.find(sd =>
          sd.amazon_shipment_id === s.amazon_shipment_id ||
          sd.amazon_shipment_confirmation_id === s.amazon_shipment_id ||
          sd.amazon_shipment_id === s.amazon_shipment_confirmation_id
        ) || shipmentsData[0];

        const localPallets = (localShipment?.pallets || []).filter(p =>
          Number(p.height) > 0 && Number(p.weight) > 0
        );
        const localFreight = localShipment?.freightInfo || {};

        const pallets = localPallets.map(p => ({
          dimensions: {
            height: Number(p.height),
            length: Number(p.length || 48),
            width: Number(p.width || 40),
            unitOfMeasurement: 'IN'
          },
          quantity: Number(p.noOfPallets || 1),
          stackability: p.stackable === 'Yes' ? 'STACKABLE' : 'NON_STACKABLE',
          weight: { unit: 'LB', value: Number(p.weight) }
        }));

        if (pallets.length > 0) {
          config.pallets = pallets;
        }

        const rawFreightClass = localFreight.class === 'estimate'
          ? (localFreight.estimatedClass || localFreight.tempoEstKey || '')
          : (localFreight.class || '');
        const freightClassNum = Number(rawFreightClass);

        if (pallets.length > 0 && freightClassNum > 0) {
          config.freightInformation = {
            declaredValue: { amount: Number(localFreight.value || 0), code: 'USD' },
            freightClass: `FC_${freightClassNum.toString().replace('.', '_')}`
          };
        }
      }
      return config;
    });

    const placementOptionId = shipments[0]?.amazon_placement_option_id;

    console.log('[GenerateTransportation] transportationDetails:', JSON.stringify(transportationDetails, null, 2));
    console.log('[GenerateTransportation] shipmentTransportationConfigurations:', JSON.stringify(shipmentTransportationConfigurations, null, 2));

    try {
      isGeneratingRef.current = true;
      setIsGenerating(true);
      const resultAction = await dispatch(GenerateTransportationOptions({
        inboundPlanId,
        placementOptionId,
        shipmentTransportationConfigurations
      }));

      const payload = resultAction.payload;

      if (payload?.success) {
        if (Array.isArray(payload.warnings) && payload.warnings.length > 0) {
          payload.warnings
            // Amazon emits this warning for every SPD shipment (no pallets = no LTL options) — expected, not an error
            .filter(msg => !msg?.toLowerCase().includes('pallet and freight info'))
            .forEach(msg => {
              notification.warning({ message: 'Transportation Warning', description: msg, duration: 8, top: 65 });
            });
        }

        const allShipmentIds = transportationDetails.map(({ shipmentId }) => shipmentId);
        if (allShipmentIds.length) {
          const dwRequests = allShipmentIds.map(shipmentId =>
            dispatch(GenerateDeliveryWindowOptions({ inboundPlanId, shipmentId }))
          );
          await Promise.all(dwRequests);
        }

        await dispatch(GetWarehouseShipments({ workOrderId }));
        await dispatch(ListTransportationOptions({ inboundPlanId, placementOptionId }));

        if (allShipmentIds.length) {
          await dispatch(ListDeliveryWindowOptions({ inboundPlanId, shipmentIds: allShipmentIds }));
        }
      }
    } catch (err) {
      console.error('Error in handleGenerateTransportationOptions:', err);
    } finally {
      isGeneratingRef.current = false;
      setIsGenerating(false);
    }
  };



  const shippingOptions = [
    { value: "amazon-ltl", label: "Amazon Freight LTL - $128.06" },
    { value: "non-partnered", label: "Non-Partnered Carrier", },
    { value: "non-partneresd", label: "Non-Parstnered Carrier", },
  ];

  // const getConfirmBtnDisabledStatus = () => {
  //   return !transportationDetails?.length || transportationDetails.some(({
  //     transportationOptionId,
  //     deliveryWindowOptionId,
  //     proNumber,
  //   }) => (
  //     !deliveryWindowOptionId ||
  //     (!transportationOptionId?.partnered && !transportationOptionId?.nonPartnered) ||
  //     (transportationOptionId?.nonPartnered && !proNumber)
  //   ));
  // };

  const [isConfirmingTransportation, setIsConfirmingTransportation] = useState(false);
  const handleConfirmTransportationOptions = async () => {
    const transportationSelections = transportationDetails.map(({ shipmentId, transportationOptionId, carrierType }) => {
      const selectedOptionId = carrierType === 'partnered' ? transportationOptionId?.partnered : transportationOptionId?.nonPartnered;
      return {
        shipmentId,
        transportationOptionId: selectedOptionId
      };
    });

    const hasMissingSelection = transportationSelections.some(selection => !selection.transportationOptionId);
    if (hasMissingSelection) {
      notification.warning({
        message: 'Confirm Transportation Options',
        description: 'Please select a transportation option for all shipments.'
      });
      return;
    }

    setIsConfirmingTransportation(true);
    const confirmRes = await dispatch(ConfirmTransportationOptions({
      inboundPlanId,
      transportationSelections
    }));

    if (confirmRes?.payload?.success) {
      const additionalRequests = transportationDetails.map(async (detail) => {
        const { shipmentId, deliveryWindowOptionId, carrierType, proNumber } = detail;
        const isSp = isSpShipment(detail);
        const tasks = [];

        if (deliveryWindowOptionId && (!isSp || (isSp && carrierType === 'non-partnered'))) {
          tasks.push(dispatch(ConfirmDeliveryWindowOption({
            inboundPlanId,
            shipmentId,
            deliveryWindowOptionId
          })));
        }

        if (carrierType === 'non-partnered' && proNumber && !isSp) {
          tasks.push(dispatch(UpdateShipmentTrackingDetails({
            inboundPlanId,
            shipmentId,
            trackingDetails: {
              ltlTrackingDetail: {
                freightBillNumber: [proNumber]
              }
            }
          })));
        }
        return Promise.all(tasks);
      });

      await Promise.all(additionalRequests);
      dispatch(GetWarehouseShipments({ workOrderId }));
      setActiveKey('4');
    } else {
      notification.error({
        message: 'Confirm Transportation Options',
        description: confirmRes?.payload?.message || 'Transportation Selections are required'
      });
    }
    setIsConfirmingTransportation(false);
  };

  const estimatedShippingFee = transportationDetails?.reduce((sum, detail) => {
    const isPartnered = detail.carrierType === 'partnered';
    const optionId = isPartnered ? detail.transportationOptionId.partnered : detail.transportationOptionId.nonPartnered;
    if (!optionId) return sum;

    const allOptions = [...(partneredOptions || []), ...(nonPartneredOptions || [])];
    const selectedOption = allOptions.find(opt => opt.transportationOptionId === optionId);
    return sum + (selectedOption?.quote?.cost?.amount || 0);
  }, 0) || 0;

  const toSnakeCase = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(toSnakeCase);
    }

    if (obj !== null && typeof obj === 'object') {
      const newObj = {};

      for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        if (key === 'transportationOptionId' && (obj.carrierType || obj.carrier_type)) {
          const carrierType = obj.carrierType || obj.carrier_type;
          if (carrierType === 'partnered') {
            newObj['partnered_id'] = obj.transportationOptionId.partnered;
          } else if (carrierType === 'non-partnered') {
            newObj['non_partnered_id'] = obj.transportationOptionId.nonPartnered;
          }
          continue;
        }

        const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        newObj[snakeKey] = toSnakeCase(obj[key]);
      }

      return newObj;
    }

    return obj;
  };

  const handleSaveBtn = () => {
    const snakeCasedDetails = toSnakeCase(transportationDetails);
    dispatch(SaveTransportationDetails({ workOrderId, transportationDetails: snakeCasedDetails }));
  };

  const handleCarrierTypeChange = (index, value) => {
    setTransportationDetails(prev => {
      const clone = cloneDeep(prev);
      clone[index] = {
        ...clone[index],
        carrierType: value,
        transportationOptionId: { partnered: '', nonPartnered: '' },
        deliveryWindowOptionId: '',
        proNumber: ''
      };
      return clone;
    });

    setSelectedPCOptions(prev => {
      const next = [...prev];
      next[index] = null;
      return next;
    });
    setPartneredCarrierValue(prev => {
      const next = [...prev];
      next[index] = null;
      return next;
    });
    setPickupDate(prev => {
      const next = [...prev];
      next[index] = null;
      return next;
    });
    setTriggerAutosave(prev => !prev);
  };

  const handleShipmentModeChange = (index, value) => {
    setTransportationDetails(prev => {
      const clone = cloneDeep(prev);
      clone[index] = {
        ...clone[index],
        shipmentType: value,
        carrierType: 'partnered',
        transportationOptionId: { partnered: '', nonPartnered: '' },
        deliveryWindowOptionId: '',
        proNumber: ''
      };
      return clone;
    });

    setSelectedPCOptions(prev => {
      const next = [...prev];
      next[index] = null;
      return next;
    });
    setPartneredCarrierValue(prev => {
      const next = [...prev];
      next[index] = null;
      return next;
    });
    setPickupDate(prev => {
      const next = [...prev];
      next[index] = null;
      return next;
    });
    setTriggerAutosave(prev => !prev);
  };

  const getConfirmBtnDisabledStatus = () => {
    return transportationDetails.some(detail => {
      const isPartnered = detail.carrierType === 'partnered';
      const isSp = isSpShipment(detail);
      const isSpNonPartnered = isSp && detail.carrierType === 'non-partnered';
      const hasOption = isPartnered ? !!detail.transportationOptionId.partnered : !!detail.transportationOptionId.nonPartnered;
      // SPD partnered: no delivery window required; SPD non-partnered + LTL: required
      const hasDeliveryWindow = (isSp && !isSpNonPartnered) ? true : !!detail.deliveryWindowOptionId;
      // SPD (any carrier) + LTL partnered: no pro number required; LTL non-partnered: required
      const hasProNumber = (isPartnered || isSp) ? true : !!detail.proNumber;
      // SPD non-partnered: all boxes must have tracking IDs
      const hasAllTrackingIds = (() => {
        if (!isSpNonPartnered) return true;
        const boxes = shipmentBoxes[detail.shipmentId] || [];
        if (!boxes.length) return false;
        const tracking = detail.spdTrackingItems || {};
        return boxes.every(b => !!tracking[b.boxId]?.trim());
      })();
      return !hasOption || !hasDeliveryWindow || !hasProNumber || !hasAllTrackingIds;
    }) || confirmingTransportationOption;
  };

  // Auto-trigger for SPD removed per user request.
  // User must now click "Generate Transportation Options" manually.
  useEffect(() => {
  }, []);

  const prevDetailsRef = useRef();

  const debouncedSave = useCallback(
    debounce((latestDetails) => {
      const snakeCased = toSnakeCase(latestDetails);
      dispatch(SaveTransportationDetails({ workOrderId, transportationDetails: snakeCased }));
    }, 2000), // 2s debounce
    [triggerAutosave]
  );

  useEffect(() => {
    const prev = prevDetailsRef.current;
    if (!prev) {
      prevDetailsRef.current = transportationDetails;
      return;
    }

    if (!isEqual(prev, transportationDetails)) {
      if (!listingTransportationOptions) {
        debouncedSave(transportationDetails);
        prevDetailsRef.current = transportationDetails;
      }
    }

    return () => debouncedSave.cancel();
  }, [triggerAutosave]);

  const prevShipDateRef = useRef(contactDetails.shipDate);
  useEffect(() => {
    if (prevShipDateRef.current !== contactDetails.shipDate && contactDetails.shipDate) {
      // Only auto-regenerate in Pack Now flow; Pack Later generates once in handleSubmitPackingInformation
      prevShipDateRef.current = contactDetails.shipDate;
    }
  }, [contactDetails.shipDate, isPackNow]);

  const configFingerprint = transportationDetails.map(d => `${d.shipmentId}:${getShipmentMode(d)}:${d.carrierType}`).join('|');
  const prevFingerprintRef = useRef(configFingerprint);

  useEffect(() => {
    if (prevFingerprintRef.current !== configFingerprint && configFingerprint) {
      // Do NOT auto-regenerate transportation options; they are generated once during submission
      prevFingerprintRef.current = configFingerprint;
    }
  }, [configFingerprint, isPackNow]);

  const isLoadingOptions = isGenerating || generatingTransportationOptionsLoading || listingTransportationOptions || fetchingWarehouseShipments || listingDeliveryWindowOptions || generatingDeliveryWindowOptionsLoading;
  const hasNoOptions = isEmpty(partneredOptions) && isEmpty(nonPartneredOptions);
  const hasAnyLtlShipment = hasLtlShipment();
  const selectedPlacement = placementOptions?.[selectedPlacementIndex] || {};
  const selectedShipment = selectedPlacement?.shipmentDetails?.[selectedShipmentIndex] || {};

  useEffect(() => {
    if (!isPackNow || !hasNoOptions || !inboundPlanId || !shipments?.length || listingTransportationOptions) return;

    const placementOptionId = shipments[0]?.amazon_placement_option_id;
    if (!placementOptionId) return;

    const fetchKey = `${inboundPlanId}:${placementOptionId}`;
    if (packNowOptionsFetchRef.current === fetchKey) return;
    packNowOptionsFetchRef.current = fetchKey;

    dispatch(ListTransportationOptions({
      inboundPlanId,
      placementOptionId
    })).then(({ payload }) => {
      const hasFetchedOptions = !isEmpty(payload?.partneredOptions) || !isEmpty(payload?.nonPartneredOptions);
      if (!hasFetchedOptions) return;

      const allShipmentIds = shipments.map(({ amazon_shipment_id }) => amazon_shipment_id);

      if (allShipmentIds.length) {
        dispatch(ListDeliveryWindowOptions({ inboundPlanId, shipmentIds: allShipmentIds }));
      }
    });
  }, [
    dispatch,
    hasNoOptions,
    inboundPlanId,
    isPackNow,
    listingTransportationOptions,
    shipments?.map(({ amazon_shipment_id }) => amazon_shipment_id).join(','),
    transportationDetails
  ]);

  // Prefetch boxes for all shipments when they become available
  useEffect(() => {
    if (!shipments?.length) return;
    shipments.forEach(({ amazon_shipment_id }) => {
      if (!amazon_shipment_id) return;
      dispatch(GetShipmentBoxes(amazon_shipment_id)).then(({ payload }) => {
        if (payload?.success) {
          setShipmentBoxes(prev => ({ ...prev, [amazon_shipment_id]: payload.boxes || [] }));
        }
      });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipments?.map(({ amazon_shipment_id }) => amazon_shipment_id).join(',')]);

  const getShipmentAddress = ({
    destination_name = '',
    destination_address_line_1 = '',
    destination_city = '',
    destination_state_or_province_code = '',
    destination_postal_code = '',
    destination_country_code = ''
  } = {}) => (
    `${destination_name} ${destination_address_line_1} ${destination_city}, ${destination_state_or_province_code} ${destination_postal_code} ${destination_country_code}`
      .trim()
      .replace(/\s+/g, ' ')
  );

  const getShipmentPartneredOptions = (shipmentId, isSp = false) => {
    const groupedOptions = (partneredOptions?.filter((option) => option.shipmentId === shipmentId) || [])
      .reduce((acc, option) => {
        const carrierName = option?.carrier?.name;
        if (!acc[carrierName]) acc[carrierName] = [];
        acc[carrierName].push(option);
        return acc;
      }, {});

    return Object.entries(groupedOptions)
      .map(([carrierName, options]) => {
        const amounts = options.map(opt => opt?.quote?.cost?.amount || 0);
        const allSame = amounts.every(amount => amount === amounts[0]);
        const priceLabel = allSame
          ? `($${amounts[0]})`
          : `($${Math.min(...amounts)} - $${Math.max(...amounts)})`;
        const sortedOptions = [...options].sort(
          (a, b) => new Date(a.carrierAppointment?.startTime) - new Date(b.carrierAppointment?.startTime)
        );

        return {
          label: `${carrierName} \n${priceLabel}`,
          value: isSp
            ? sortedOptions[0]?.transportationOptionId
            : sortedOptions.map(opt => ({
              label: `${dayjs(opt?.carrierAppointment?.startTime).format("MMMM D, YYYY")} \n($${opt?.quote?.cost?.amount})`,
              value: opt?.transportationOptionId
            })),
          minPrice: Math.min(...amounts),
          transportationOptionIds: sortedOptions.map(opt => opt?.transportationOptionId)
        };
      })
      .sort((a, b) => a.minPrice - b.minPrice)
      .map(({ minPrice, ...rest }) => rest);
  };

  const getShipmentNonPartneredOptions = (shipmentId, isSp) => {
    const seen = new Set();
    const expectedMode = isSp ? 'GROUND_SMALL_PARCEL' : 'FREIGHT_LTL';
    return (nonPartneredOptions?.filter((option) => option.shipmentId === shipmentId && option.shippingMode === expectedMode) || [])
      .filter(option => { if (seen.has(option.carrier.name)) return false; seen.add(option.carrier.name); return true; })
      .map(option => ({ value: option.transportationOptionId, label: option.carrier.name }));
  };

  const getShipmentDeliveryWindowOptions = (shipmentId) => (
    [...(deliveryWindowOptions[shipmentId] || [])]
      .sort((a, b) => dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf())
      .map(({ startDate, endDate, deliveryWindowOptionId: value }) => ({
        value,
        label: `${dayjs(startDate).format("MMMM D, YYYY")} - ${dayjs(endDate).format("MMMM D, YYYY")}`
      }))
  );


  const renderPackNowContactAndShipDate = () => {
    const { name, phone, email, shipDate } = contactDetails || {};

    return (
      <div className='items-info-wrapper'>
        <div className='info-inputs'>
       
          <div className='info-items'>
            <Input
              label="Name"
              important
              placeholder="Enter"
              value={name}
              onChange={({ target }) => setContactDetails(prev => ({ ...prev, name: target.value }))}
            />
            <Input
              label="Phone Number"
              important
              placeholder="Enter"
              value={phone}
              onChange={({ target }) => setContactDetails(prev => ({ ...prev, phone: target.value }))}
            />
            <Input
              label="Email Address"
              important
              placeholder="Enter"
              value={email}
              onChange={({ target }) => setContactDetails(prev => ({ ...prev, email: target.value }))}
            />
          </div>
        </div>
        <div className='info-inputs'>
      
          <div className='date-time'>
            <span style={{ display: 'flex' }}>
              <label>Ready to Ship Date</label>
              <p style={{ color: 'red', fontSize: 12 }}>*</p>
            </span>
            <DatePicker
              className='new-date-picker-ready-to-ship'
              value={shipDate ? moment(shipDate) : null}
              format='YYYY-MM-DD'
              onChange={(date, dateStr) => confirmReset(() => setContactDetails(prev => ({ ...prev, shipDate: dateStr })))}
              disabledDate={(current) => current && !current.isAfter(moment(), 'day')}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderPackNowPalletSetup = (shipment, index, {
    showModeToggle = true,
    includeTransportation = false
  } = {}) => {
    const detail = transportationDetails[index] || {};
    const isLtl = getShipmentMode(detail) === 'LTL';
    const shipmentRowIndex = shipmentsData.findIndex(sd => sd.amazon_shipment_id === shipment.amazon_shipment_id);
    const shipmentRow = shipmentsData[shipmentRowIndex] || {};
    const { pallets = [], freightInfo = {} } = shipmentRow;
    const estimatedClass = calculateFreightClass(pallets);
    const freightOptions = [
      { value: 'estimate', label: `Estimate (${estimatedClass})`, estimatedExtraKey: estimatedClass },
      ...sellerFreightClassValues.slice(1)
    ];

    return (
      <div className='grid-items' key={shipment.amazon_shipment_id}>
        <div className='grid-items-header-info'>
          <div className="shipment-header-titles">
            <h6>
              {shipment.amazon_shipment_confirmation_id || shipment.amazon_shipment_id}
              {!showModeToggle && (
                <>
                  <Divider type='vertical' />
                  {shipment.amazon_reference_id || '---'}
                </>
              )}
            </h6>
            {showModeToggle ? (
              <div style={{ display: 'flex', alignItems: 'center', gridGap: 8 }}>
                <p className='shipping-mode'>{getShipmentMode(detail) === 'SP' ? 'SPD' : 'LTL'}</p>
                <Radio.Group
                  size="small"
                  value={getShipmentMode(detail)}
                  onChange={({ target }) => handleShipmentModeChange(index, target.value)}
                >
                  <Radio.Button value="SP">SPD</Radio.Button>
                  <Radio.Button value="LTL">LTL</Radio.Button>
                </Radio.Group>
              </div>
            ) : (
              <p className='shipping-mode'>{getShipmentMode(detail) === 'SP' ? 'SPD' : 'LTL'}</p>
            )}
          </div>
          <div className='grid-items-header-info-child-info'>
            <p><span>Location:</span> <span>{shipment.amazon_warehouse_id}</span></p>
            <Divider type="vertical" />
            <p><span>SKUs:</span> <span>{shipment.shipment_items_info?.length || '-'}</span></p>
            <Divider type="vertical" />
            <p><span>Units:</span> <span>{shipment.boxes_info?.reduce((sum, curr) => sum + Number(curr.units || 0), 0)}</span></p>
            <Divider type="vertical" />
            <p><span>Boxes Count:</span> <span>{shipment.boxes_info?.length || '-'}</span></p>
          </div>
        </div>
        <div className='items-ui-wrappers'>
          {isLtl && (
            <>
              <div className='items'>
                <p>Freight Information</p>
                <div className='items-child'>
                  <Input
                    placeholder='Enter'
                    label='Total Value'
                    value={
                      isNaN(Number(freightInfo?.value)) || Number(freightInfo?.value) === 0
                        ? ''
                        : Number(freightInfo?.value)
                    }
                    onChange={({ target }) => handleFreightInfoUpdate(shipmentRowIndex, 'value', target.value)}
                  />
                  <ReactSelect
                    menuPlacement='auto'
                    options={freightOptions}
                    placeholder='Enter'
                    label='Freight Class'
                    important
                    style={{ width: '100%' }}
                    value={
                      freightInfo.class === 'estimate'
                        ? freightOptions[0]
                        : freightOptions.find(option => option.value === Number(freightInfo.class)) || null
                    }
                    onChange={(e) => handleFreightInfoUpdate(shipmentRowIndex, 'class', e?.value, e?.estimatedExtraKey)}
                  />
                </div>
              </div>
              <div className='pallets-info'>
                <span style={{ display: 'flex' }}>
                  <p>Pallets</p>
                  <p style={{ color: 'red', fontSize: 12 }}>*</p>
                </span>
                <Button text="Add New" onClick={() => addPalletRow(shipmentRowIndex)} />
              </div>
              <div className='items-overlay-wrapper'>
                {pallets.map((pallet, palletIndex) => (
                  <div className='items-wrapper' key={`pallet-${shipment.amazon_shipment_id}-${palletIndex}`}>
                    <Input placeholder='40' label={palletIndex === 0 && 'Length (in)'} disabled />
                    <Input placeholder='48' label={palletIndex === 0 && 'Width (in)'} disabled />
                    <Input
                      placeholder='Enter'
                      important
                      label={palletIndex === 0 && 'Height (in)'}
                      value={pallet.height || ''}
                      onChange={({ target }) => handlePalletUpdate(shipmentRowIndex, palletIndex, 'height', target.value)}
                    />
                    <Input
                      placeholder='Enter'
                      important
                      label={palletIndex === 0 && 'Weight (lb)'}
                      value={pallet.weight || ''}
                      onChange={({ target }) => handlePalletUpdate(shipmentRowIndex, palletIndex, 'weight', target.value)}
                    />
                    <ReactSelect
                      menuPlacement={pallets.length - 1 === palletIndex ? 'top' : 'auto'}
                      menuPortalTarget={document.body}
                      options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]}
                      placeholder='Yes'
                      label={palletIndex === 0 && 'Stackable'}
                      important
                      style={{ width: '100%' }}
                      value={pallet.stackable ? { value: pallet.stackable, label: pallet.stackable } : null}
                      onChange={(e) => handlePalletUpdate(shipmentRowIndex, palletIndex, 'stackable', e?.value)}
                    />
                    <Input
                      placeholder='Enter'
                      important
                      label={palletIndex === 0 && 'No. of Pallets'}
                      value={pallet.noOfPallets || ''}
                      onChange={({ target }) => handlePalletUpdate(shipmentRowIndex, palletIndex, 'noOfPallets', target.value)}
                    />
                    <div className='actions-wrapper'>
                      {palletIndex === 0 && <label>Actions</label>}
                      <img
                        onClick={() => removePalletRow(shipmentRowIndex, palletIndex, pallet.id)}
                        src={DeleteIcon}
                        alt='DeleteIcon'
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        {includeTransportation && (
          <StepThreeWrapper className='show-global'>
            <div className='view-card-global-wrapper'>
              {renderTransportationCard(shipment, index)}
            </div>
          </StepThreeWrapper>
        )}
      </div>
    );
  };

  const renderTransportationCard = (shipment, index) => {
    const detail = transportationDetails[index] || {};
    const shipmentMode = getShipmentMode(detail);
    const isSp = shipmentMode === 'SP';
    const shipmentPartneredOptions = getShipmentPartneredOptions(shipment.amazon_shipment_id, isSp);
    const shipmentNonPartneredOptions = getShipmentNonPartneredOptions(shipment.amazon_shipment_id, isSp);
    const shipmentDeliveryWindowOptions = getShipmentDeliveryWindowOptions(shipment.amazon_shipment_id);
    const formattedAddress = getShipmentAddress(shipment);
    const {
      carrierType,
      transportationOptionId = {},
      deliveryWindowOptionId,
      proNumber,
    } = detail;
    const selectedPartneredCarrier = isSp
      ? shipmentPartneredOptions.find(option => option.value === transportationOptionId?.partnered)
      : shipmentPartneredOptions.find((option) =>
        option.value?.some((subOption) => subOption.value === transportationOptionId?.partnered)
      );
    const pickupOptionsForShipment = selectedPCOptions[index] || selectedPartneredCarrier?.value || [];

    const updateTransportationDetail = (updater) => {
      setTransportationDetails(prev => {
        const clone = cloneDeep(prev);
        clone[index] = updater(clone[index] || {});
        return clone;
      });
      setTriggerAutosave(prev => !prev);
    };

    return (
      <div key={shipment.amazon_shipment_id || index} className='view-card-global'>
        <div className='inner-content'>
          <div className='career-items-wrapper'>
            <div className='items-wrapper'>
              <span className='item-text-wrapper'>Ship To: </span>
              <span className='item-text-wrapper'>{formattedAddress}</span>
            </div>
            <span style={{ display: 'flex' }}>
              <p>Carrier Information</p>
              <p style={{ color: 'red', fontSize: 12 }}>*</p>
            </span>
            <div className='radio-items'>
              <Radio.Group
                value={carrierType}
                onChange={({ target }) => handleCarrierTypeChange(index, target.value)}
              >
                <div className='items-wrapper'>
                  <Radio
                    key='partnered'
                    value='partnered'
                    disabled={!listingTransportationOptions && !shipmentPartneredOptions?.length}
                  />
                  <div className='items-wrapper-select'>
                    <ReactSelect
                      menuPlacement='top'
                      ref={(el) => (selectRefs.current[index] = el)}
                      options={listingTransportationOptions ? [] : shipmentPartneredOptions}
                      placeholder='Partnered Carrier'
                      disabled={!listingTransportationOptions && !shipmentPartneredOptions?.length}
                      loading={listingTransportationOptions}
                      value={
                        listingTransportationOptions
                          ? ''
                          : isSp
                            ? selectedPartneredCarrier
                            : transportationOptionId?.partnered && !!partneredCarrierValue[index]
                              ? partneredCarrierValue[index]
                              : selectedPartneredCarrier
                      }
                      onChange={(selectedOption) => {
                        if (isSp) {
                          updateTransportationDetail(current => ({
                            ...current,
                            carrierType: 'partnered',
                            transportationOptionId: {
                              partnered: selectedOption?.value || '',
                              nonPartnered: ''
                            },
                            deliveryWindowOptionId: '',
                            proNumber: ''
                          }));
                          return;
                        }

                        const matchedCarrier = shipmentPartneredOptions.find(
                          carrier => carrier.label.trim() === selectedOption?.label?.trim()
                        );
                        setPartneredCarrierValue(carrierValues => {
                          const carrierValuesClone = cloneDeep(carrierValues);
                          carrierValuesClone[index] = selectedOption;
                          return carrierValuesClone;
                        });
                        setPickupDate(pickup => {
                          const pickupClone = cloneDeep(pickup);
                          pickupClone[index] = matchedCarrier?.value?.[0] || null;
                          return pickupClone;
                        });
                        setSelectedPCOptions(options => {
                          const optionsClone = cloneDeep(options);
                          optionsClone[index] = selectedOption?.value;
                          return optionsClone;
                        });
                        updateTransportationDetail(current => ({
                          ...current,
                          carrierType: 'partnered',
                          transportationOptionId: {
                            partnered: matchedCarrier?.transportationOptionIds?.[0] || '',
                            nonPartnered: ''
                          },
                          deliveryWindowOptionId: '',
                          proNumber: ''
                        }));
                      }}
                    />
                    {(!listingTransportationOptions && !shipmentPartneredOptions?.length) && <p>Amazon PCP not available</p>}
                  </div>
                </div>
                <div className='items-wrapper'>
                  <Radio key='non-partnered' value='non-partnered' />
                  <div className='items-wrapper-select'>
                    <ReactSelect
                      menuPlacement='top'
                      options={listingTransportationOptions ? [] : shipmentNonPartneredOptions}
                      placeholder='Non-Partnered Carrier'
                      loading={listingTransportationOptions}
                      value={
                        listingTransportationOptions ? '' :
                          transportationOptionId?.nonPartnered ?
                            shipmentNonPartneredOptions.find(option => option.value === transportationOptionId?.nonPartnered)
                            : null
                      }
                      onChange={({ value }) => {
                        updateTransportationDetail(current => ({
                          ...current,
                          carrierType: 'non-partnered',
                          transportationOptionId: {
                            partnered: '',
                            nonPartnered: value
                          },
                          deliveryWindowOptionId: '',
                          proNumber: ''
                        }));
                      }}
                    />
                  </div>
                </div>
              </Radio.Group>
              {(!isSp || carrierType === 'non-partnered') && (
                <div className='non-radio-fields'>
                  {!isSp && carrierType === 'non-partnered' && (
                    <Input
                      placeholder='Enter'
                      label='Pro Number'
                      disabled={transportationOptionId.nonPartnered === ''}
                      value={listingTransportationOptions ? null : proNumber}
                      important
                      onChange={({ target }) => {
                        updateTransportationDetail(current => ({
                          ...current,
                          proNumber: target?.value
                        }));
                      }}
                    />
                  )}
                  {!isSp && carrierType === 'partnered' && (
                    <ReactSelect
                      menuPlacement='top'
                      options={pickupOptionsForShipment}
                      label='Pickup Dates'
                      placeholder='Select'
                      disabled={(!listingTransportationOptions && !shipmentPartneredOptions?.length) || transportationOptionId?.partnered === ''}
                      loading={listingTransportationOptions}
                      value={
                        partneredCarrierValue[index]
                          ? pickupDate[index]
                          : (listingTransportationOptions
                            ? null
                            : transportationOptionId?.partnered &&
                            pickupOptionsForShipment?.find(option => option?.value === transportationOptionId?.partnered))
                      }
                      onChange={({ label, value }) => {
                        setPickupDate(pickup => {
                          const pickupClone = cloneDeep(pickup);
                          pickupClone[index] = { label, value };
                          return pickupClone;
                        });
                        updateTransportationDetail(current => ({
                          ...current,
                          carrierType: 'partnered',
                          transportationOptionId: {
                            partnered: value,
                            nonPartnered: ''
                          },
                          deliveryWindowOptionId: '',
                          proNumber: ''
                        }));
                      }}
                    />
                  )}
                  <ReactSelect
                    important
                    menuPlacement='top'
                    label='Select Delivery Window'
                    options={listingTransportationOptions ? [] : shipmentDeliveryWindowOptions}
                    placeholder="(December 9, 2024)  -  (December 10, 2024)"
                    loading={listingDeliveryWindowOptions || listingTransportationOptions || generatingDeliveryWindowOptionsLoading}
                    value={listingTransportationOptions ? null : (deliveryWindowOptionId ? shipmentDeliveryWindowOptions.find(option => option.value === deliveryWindowOptionId) : null)}
                    disabled={
                      isEmpty(deliveryWindowOptions) || !carrierType || (
                        isSp
                          ? !transportationOptionId?.nonPartnered
                          : ((carrierType === 'non-partnered' && !proNumber) || (carrierType === 'partnered' && transportationOptionId?.partnered === ''))
                      )
                    }
                    onChange={({ value }) => {
                      updateTransportationDetail(current => ({
                        ...current,
                        deliveryWindowOptionId: value
                      }));
                    }}
                  />
                </div>
              )}
              {isSp && carrierType === 'non-partnered' && (
                <div style={{ marginTop: '16px' }}>
                  <label style={{ fontSize: '13px', color: '#1D2129', fontWeight: 600, display: 'block', marginBottom: '10px' }}>
                    Box Tracking IDs <span style={{ color: 'red' }}>*</span>
                  </label>
                  {shipmentBoxes[shipment.amazon_shipment_id] ? (
                    shipmentBoxes[shipment.amazon_shipment_id].length > 0 ? (
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '12px 20px',
                        background: '#F7F8FA',
                        borderRadius: '8px',
                        padding: '14px 16px',
                        border: '1px solid #E5E6EB'
                      }}>
                        {shipmentBoxes[shipment.amazon_shipment_id].map(box => (
                          <div key={box.boxId}>
                            <label style={{
                              fontSize: '12px',
                              color: '#4E5969',
                              fontWeight: 500,
                              display: 'block',
                              marginBottom: '4px'
                            }}>
                              <span style={{
                                display: 'inline-block',
                                background: '#E8F3FF',
                                color: '#1565D8',
                                fontSize: '11px',
                                fontWeight: 600,
                                padding: '1px 6px',
                                borderRadius: '4px',
                                marginRight: '6px'
                              }}>
                                {box.boxId}
                              </span>
                            </label>
                            <Input
                              placeholder='Enter Tracking Number'
                              value={detail.spdTrackingItems?.[box.boxId] || ''}
                              onChange={({ target }) => {
                                updateTransportationDetail(current => ({
                                  ...current,
                                  spdTrackingItems: {
                                    ...(current.spdTrackingItems || {}),
                                    [box.boxId]: target.value
                                  }
                                }));
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p style={{ fontSize: '12px', color: '#86909C' }}>No boxes found for this shipment.</p>
                    )
                  ) : (
                    <p style={{ fontSize: '12px', color: '#86909C' }}>Loading boxes...</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };


  // ── Pack Later: original LTL carrier selection view (rendered inline from ShipmentPallets) ──
  if (!isPackNow && showTransportGlobal && !isEmpty(shipments)) {
    return (
      <Spin tip='Loading...' spinning={isLoadingOptions}>
        <StepThreeWrapper className='show-global'>
          <div className='view-card-global-wrapper'>
            {shipments?.map(({
              amazon_shipment_confirmation_id,
              amazon_reference_id,
              amazon_shipment_id,
              destination_address_line_1: address_line1,
              destination_city: city,
              destination_country_code: country,
              destination_name: name,
              destination_postal_code: postal_code,
              destination_state_or_province_code: state,
            }, index) => {
              if (amazon_shipment_id !== shipmentIdOuter) return null;
              const formattedAddress = `${name} ${address_line1} ${city}, ${state} ${postal_code} ${country}`;
              let amzShipmentOptions = partneredOptions?.filter((option) => option.shipmentId === amazon_shipment_id) || [];
              const groupedOptions = amzShipmentOptions.reduce((acc, option) => {
                const carrierName = option?.carrier?.name;
                if (!acc[carrierName]) {
                  acc[carrierName] = [];
                }
                acc[carrierName].push(option);
                return acc;
              }, {});

              const shipmentPartneredOptions = Object.entries(groupedOptions).map(
                ([carrierName, options]) => {
                  const amounts = options.map(opt => opt?.quote?.cost?.amount);
                  const allSame = amounts.every(amount => amount === amounts[0]);

                  const priceLabel = allSame
                    ? `($${amounts[0]})`
                    : `($${Math.min(...amounts)} - $${Math.max(...amounts)})`;

                  const sortedOptions = options.sort(
                    (a, b) =>
                      new Date(a.carrierAppointment?.startTime) -
                      new Date(b.carrierAppointment?.startTime)
                  );

                  return {
                    label: `${carrierName} \n${priceLabel}`,
                    value: sortedOptions.map(opt => ({
                      label: `${dayjs(opt?.carrierAppointment?.startTime).format("MMMM D, YYYY")} \n($${opt?.quote?.cost?.amount})`,
                      value: opt?.transportationOptionId
                    })),
                    minPrice: Math.min(...amounts),
                    transportationOptionIds: groupedOptions[carrierName].map(opt => opt?.transportationOptionId),
                  };
                }
              ).sort((a, b) => a.minPrice - b.minPrice).map(({ minPrice, ...rest }) => rest);

              const shipmentNonPartneredOptions = (nonPartneredOptions?.filter((option) => option.shipmentId === amazon_shipment_id) || [])
                ?.map((option) => ({ value: option.transportationOptionId, label: option.carrier.name }));

              const shipmentDeliveryWindowOptions = [...(deliveryWindowOptions[amazon_shipment_id] || [])]
                ?.sort((a, b) => dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf())
                ?.map(({ startDate, endDate, deliveryWindowOptionId: value }) => ({ value, label: `${dayjs(startDate).format("MMMM D, YYYY")} - ${dayjs(endDate).format("MMMM D, YYYY")}` }));

              const {
                carrierType,
                transportationOptionId,
                deliveryWindowOptionId,
                proNumber,
              } = transportationDetails[index] || {};

              return (
                <div key={index} className='view-card-global'>
                  <div className='inner-content'>
                    <div className='career-items-wrapper'>
                      <div className='items-wrapper'>
                        <span className='item-text-wrapper'>Ship To: </span>
                        <span className='item-text-wrapper'>{formattedAddress}</span>
                      </div>
                      <span style={{ display: 'flex' }}>
                        <p>Carrier Information</p>
                        <p style={{ color: 'red', fontSize: 12 }}>*</p>
                      </span>
                      <div className='radio-items'>
                        <Radio.Group
                          onChange={({ target }) => {
                            setTransportationDetails(transportationDetails => {
                              const transportationDetailsClone = cloneDeep(transportationDetails);
                              transportationDetailsClone[index].carrierType = target?.value;
                              transportationDetailsClone[index].transportationOptionId.partnered = '';
                              transportationDetailsClone[index].transportationOptionId.nonPartnered = '';
                              transportationDetailsClone[index].deliveryWindowOptionId = '';
                              transportationDetailsClone[index].proNumber = '';
                              return transportationDetailsClone;
                            });
                            setPartneredCarrierValue(prev => {
                              const clone = cloneDeep(prev);
                              clone[index] = null;
                              return clone;
                            });
                            setPickupDate(prev => {
                              const clone = cloneDeep(prev);
                              clone[index] = null;
                              return clone;
                            });
                            setSelectedPCOptions(prev => {
                              const clone = cloneDeep(prev);
                              clone[index] = null;
                              return clone;
                            });
                            setTriggerAutosave(prev => !prev);
                          }}
                          value={carrierType}
                        >
                          <div className='items-wrapper'>
                            <Radio
                              key={'partnered'}
                              value={'partnered'}
                              disabled={!listingTransportationOptions && !shipmentPartneredOptions?.length}
                            />
                            <div className='items-wrapper-select'>
                              <ReactSelect
                                menuPlacement='top'
                                ref={(el) => (selectRefs.current[index] = el)}
                                options={listingTransportationOptions ? [] : shipmentPartneredOptions}
                                placeholder='Partnered Carrier'
                                disabled={!listingTransportationOptions && !shipmentPartneredOptions?.length}
                                loading={listingTransportationOptions}
                                value={
                                  listingTransportationOptions
                                    ? ''
                                    : transportationOptionId?.partnered && !!partneredCarrierValue[index]
                                      ? partneredCarrierValue[index]
                                      : shipmentPartneredOptions.find((option) =>
                                        option.value.some((subOption) => subOption.value === transportationOptionId?.partnered)
                                      )
                                }
                                onChange={({ label, value }) => {
                                  setPartneredCarrierValue(carrierValues => {
                                    const carrierValuesClone = cloneDeep(carrierValues);
                                    carrierValuesClone[index] = { label, value };
                                    return carrierValuesClone;
                                  });
                                  if (!pickupDate[index]?.value) {
                                    setPickupDate(pickup => {
                                      const pickupClone = cloneDeep(pickup);
                                      pickupClone[index] = null;
                                      return pickupClone;
                                    });
                                  }
                                  const matchedCarrier = shipmentPartneredOptions.find(
                                    carrier => carrier.label.trim() === label.trim()
                                  );
                                  setPickupDate(pickup => {
                                    const pickupClone = cloneDeep(pickup);
                                    pickupClone[index] = matchedCarrier?.value[0];
                                    return pickupClone;
                                  })
                                  setSelectedPCOptions(options => {
                                    const optionsClone = cloneDeep(options);
                                    optionsClone[index] = value;
                                    return optionsClone;
                                  })
                                  setTransportationDetails(transportationDetails => {
                                    const transportationDetailsClone = cloneDeep(transportationDetails);
                                    transportationDetailsClone[index].carrierType = 'partnered';
                                    transportationDetailsClone[index].transportationOptionId.partnered = matchedCarrier?.transportationOptionIds[0];
                                    transportationDetailsClone[index].transportationOptionId.nonPartnered = '';
                                    transportationDetailsClone[index].deliveryWindowOptionId = '';
                                    transportationDetailsClone[index].proNumber = '';
                                    return transportationDetailsClone;
                                  });
                                  setTriggerAutosave(prev => !prev);
                                }}
                              />
                              {(!listingTransportationOptions && !shipmentPartneredOptions?.length) && <p>Amazon PCP not available</p>}
                            </div>
                          </div>
                          <div className='items-wrapper'>
                            <Radio
                              key={'non-partnered'}
                              value={'non-partnered'}
                            />
                            <div className='items-wrapper-select'>
                              <ReactSelect
                                menuPlacement='top'
                                options={listingTransportationOptions ? [] : shipmentNonPartneredOptions}
                                placeholder='Non-Partnered Carrier'
                                loading={listingTransportationOptions}
                                value={
                                  listingTransportationOptions ? '' :
                                    transportationOptionId?.nonPartnered ?
                                      shipmentNonPartneredOptions.find(option => option.value === transportationOptionId?.nonPartnered)
                                      : null
                                }
                                onChange={({ value }) => {
                                  setTransportationDetails(transportationDetails => {
                                    const transportationDetailsClone = cloneDeep(transportationDetails);
                                    transportationDetailsClone[index].transportationOptionId.nonPartnered = value;
                                    transportationDetailsClone[index].transportationOptionId.partnered = '';
                                    transportationDetailsClone[index].carrierType = 'non-partnered';
                                    transportationDetailsClone[index].deliveryWindowOptionId = '';
                                    return transportationDetailsClone;
                                  });
                                  setTriggerAutosave(prev => !prev);
                                }}
                              />
                            </div>
                          </div>
                        </Radio.Group>
                        <div className='non-radio-fields'>

                          {
                            (carrierType === 'non-partnered') &&
                            <Input
                              placeholder='Enter'
                              label='Pro Number'
                              disabled={transportationOptionId.nonPartnered === ''}
                              value={listingTransportationOptions ? null : proNumber}
                              important={true}
                              onChange={({ target }) => {
                                setTransportationDetails(transportationDetails => {
                                  const transportationDetailsClone = cloneDeep(transportationDetails);
                                  transportationDetailsClone[index].proNumber = target?.value;
                                  return transportationDetailsClone;
                                });
                                setTriggerAutosave(prev => !prev);
                              }}
                            />
                          }
                          {
                            carrierType === 'partnered' &&
                            (
                              <ReactSelect
                                menuPlacement='top'
                                options={selectedPCOptions[index]}
                                label={'Pickup Dates'}
                                placeholder='Select'
                                disabled={(!listingTransportationOptions && !shipmentPartneredOptions?.length ) || transportationOptionId?.partnered === ''}
                                loading={listingTransportationOptions}
                                value={
                                  partneredCarrierValue[index]
                                    ? pickupDate[index]
                                    : (listingTransportationOptions
                                      ? null
                                      : transportationOptionId?.partnered &&
                                      selectedPCOptions[index]?.find(option => option?.value === transportationOptionId?.partnered))
                                }
                                onChange={({ label, value }) => {
                                  setPickupDate(pickup => {
                                    const pickupClone = cloneDeep(pickup);
                                    pickupClone[index] = { label, value };
                                    return pickupClone;
                                  });
                                  setTransportationDetails(transportationDetails => {
                                    const transportationDetailsClone = cloneDeep(transportationDetails);
                                    transportationDetailsClone[index].transportationOptionId.partnered = value;
                                    transportationDetailsClone[index].transportationOptionId.nonPartnered = '';
                                    transportationDetailsClone[index].carrierType = 'partnered';
                                    transportationDetailsClone[index].deliveryWindowOptionId = '';
                                    transportationDetailsClone[index].proNumber = '';

                                    return transportationDetailsClone;
                                  });
                                  setTriggerAutosave(prev => !prev);
                                }}

                              />

                            )
                          }

                          <ReactSelect
                            important={true}
                            menuPlacement='top'
                            label='Select Delivery Window'
                            options={listingTransportationOptions ? [] : shipmentDeliveryWindowOptions}
                            placeholder="(December 9, 2024)  -  (December 10, 2024)"
                            loading={listingDeliveryWindowOptions || listingTransportationOptions}
                            value={listingTransportationOptions ? null : (deliveryWindowOptionId ? shipmentDeliveryWindowOptions.find(option => option.value === deliveryWindowOptionId) : null)}
                            disabled={isEmpty(deliveryWindowOptions) || !carrierType || ((carrierType === 'non-partnered' && !(proNumber)) || (carrierType === 'partnered'  && transportationOptionId?.partnered === '')) }
                            onChange={({ value }) => {
                              setTransportationDetails(transportationDetails => {
                                const transportationDetailsClone = cloneDeep(transportationDetails);
                                transportationDetailsClone[index].deliveryWindowOptionId = value;
                                return transportationDetailsClone;
                              });
                              setTriggerAutosave(prev => !prev);
                            }}
                          />

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </StepThreeWrapper>
      </Spin>
    );
  }

  if (isPackNow && hasNoOptions && !isEmpty(shipments)) {
    return (
      <ContactInformationWrapper style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', top: '16px', right: '16px', zIndex: 10 }}>
          <Button
            text="📦 Pack & Scan"
            className="primary"
            onClick={() => setPackScanVisible(true)}
            style={{ 
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
              color: 'white',
              border: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              padding: '10px 24px',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
              cursor: 'pointer'
            }}
          />
        </div>
        <Spin tip='Loading...' spinning={isLoadingOptions}>
          {renderPackNowContactAndShipDate()}
          <div className={`cards-shipment-items-grid ${shipments?.length === 1 ? 'cards-shipment-items-grid--single' : ''}`}>
            {shipments?.map(renderPackNowPalletSetup)}
          </div>
        </Spin>
        <PackScanModal
          open={packScanVisible}
          onClose={() => setPackScanVisible(false)}
          workOrderId={workOrderId}
          forcedPageType="PackageLabel_Thermal_NonPCP"
        />
        <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end', gap: '12px', alignItems: 'center' }}>
          <Button
            text="Cancel Plan"
            className="danger mb-0"
            minWidth="90px"
            disabled={cancelingInboundPlan}
            onClick={onCancelPlan}
          />
          <Button
            text={isLoadingOptions ? 'Generating...' : 'Generate Transportation Options'}
            className="mb-0"
            minWidth="90px"
            disabled={
              isLoadingOptions ||
              !contactDetails.shipDate ||
              (!contactDetails.name || !contactDetails.phone || !contactDetails.email) ||
              !isPalletsComplete()
            }
            onClick={() => handleGenerateTransportationOptions(true)}
          />
        </div>
      </ContactInformationWrapper>
    );
  }

  if (isPackNow && !hasNoOptions && !isEmpty(shipments)) {
    return (
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', top: '16px', right: '16px', zIndex: 10 }}>
          <Button
            text="📦 Pack & Scan"
            className="primary"
            onClick={() => setPackScanVisible(true)}
            style={{ 
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
              color: 'white',
              border: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              padding: '10px 24px',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
              cursor: 'pointer'
            }}
          />
        </div>
        <ContactInformationWrapper>
          <Spin tip='Processing...' spinning={isLoadingOptions}>
            {renderPackNowContactAndShipDate()}
            <div className='cards-shipment-items-grid'>
              {shipments?.map((shipment, index) => renderPackNowPalletSetup(shipment, index, {
                showModeToggle: false,
                includeTransportation: true
              }))}
            </div>
          </Spin>
        </ContactInformationWrapper>
        <PackScanModal
          open={packScanVisible}
          onClose={() => setPackScanVisible(false)}
          workOrderId={workOrderId}
          forcedPageType="PackageLabel_Thermal_NonPCP"
        />
        <Modal
          saveText="Yes"
          className="Delete-modal-wrapper-item"
          onClose={() => {
            setIsResetModalVisible(false);
            setResetCallback(null);
          }}
          onSave={handleResetConfirm}
          closeText="Cancel"
          centerAlign
          size="small"
          open={isResetModalVisible}
          removeIcon
        >
          <AlertModalStyleWrapper>
            <div className='alert-modal-wrapper'>
              <img src={AlterIcon1} alt='AlertIcon' title='AlertIcon' />
              <Typography fontSize={24} component="h3" marginTop={3}>Want to edit?</Typography>
              <p>Are you sure you want to edit the information? you will lose the Carrier information</p>
            </div>
          </AlertModalStyleWrapper>
        </Modal>
      </div>
    );
  }

  return (
    <Spin tip='Processing...' spinning={isLoadingOptions}>
      <StepThreeWrapper className={`${showTransportGlobal ? 'show-global' : 'hide-global'}`}>
        {isPackNow && (
          <div style={{ position: 'absolute', top: '-10px', right: '0px', zIndex: 10 }}>
            <Button
              text="📦 Pack & Scan"
              className="primary"
              onClick={() => setPackScanVisible(true)}
              style={{ 
                background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                color: 'white',
                border: 'none',
                fontWeight: 700,
                borderRadius: '8px',
                padding: '10px 24px',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
                cursor: 'pointer'
              }}
            />
          </div>
        )}
        {listingPlacementOptions ? (
          <div className='loading-wrapper'>
         
          </div>
        ) : (isPackNow && isEmpty(shipments) && !isEmpty(placementOptions)) ? (
          <>
            <div className={`cards-overlay-wrapper ${listingPlacementOptions ? 'loading-accured' : ''}`}>
              <Spin wrapperClassName="placement-cards-loading" tip='Loading...' spinning={listingPlacementOptions}>
                <PlacementCard
                  cardsData={placementOptions?.map((opt, idx) => ({
                    id: opt.placementOptionId,
                    placementOption: `Placement Option ${idx + 1}`,
                    shipments: opt.shipmentDetails?.length || 0,
                    discount: opt.discounts?.reduce((total, fee) => total + (fee?.value?.amount || 0), 0) || 0,
                    expiry: opt.expiration ? dayjs(opt.expiration).format('M/D/YY') : '',
                    placementFee: opt.fees?.reduce((total, fee) => total + (fee?.value?.amount || 0), 0) || 0
                  }))}
                  activePlacementIndex={selectedPlacementIndex}
                  selectPlacementOption={(index) => {
                    setSelectedPlacementIndex(index);
                    setSelectedShipmentIndex(0);
                  }}
                />
              </Spin>
            </div>
            <div className='content-area-wrapper'>
              <Spin tip='Loading...' wrapperClassName="placement-cards-loading" spinning={listingPlacementOptions || confirmingPlacementOption}>
                <div className='tabs-cards-wrapper'>
                  {selectedPlacement?.shipmentDetails?.map((item, index) => (
                    <div key={item.shipmentId}
                      className={`tab-item-wrapper ${selectedShipmentIndex === index ? 'active' : ''}`}
                      onClick={() => setSelectedShipmentIndex(index)}>
                      <div className='tab-item'>
                        <p>FC ID</p>
                        <p>{item?.destinationCenterId || '---'}</p>
                      </div>
                      <div className='tab-item'>
                        <p>SKUs Count</p>
                        <p>{item?.items?.length || 0}</p>
                      </div>
                      <div className='tab-item'>
                        <p>No of bundles</p>
                        <p>
                          {item?.items?.reduce((sum, i) => sum + Number(i?.quantity || 0), 0)}
                        </p>
                      </div>
                      <div className='tab-item'>
                        <p>Mileage (mi)</p>
                        <p>{item?.miles || '---'}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div ref={tableSectionRef}>
                  <AgGrid
                    key={`${selectedPlacement?.placementOptionId || selectedPlacementIndex}-${selectedShipment?.shipmentId || selectedShipmentIndex}`}
                    user_referrals={selectedShipment?.items?.map((item, index) => ({
                      ...item,
                      image_url: item.image_url || ProductImg,
                      title: item.item_name || item.msku,
                      __rowId: `${selectedShipment?.shipmentId || selectedShipmentIndex}-${item.msku || item.sku || item.asin || index}`
                    })) || []}
                    defaultColDef={{
                      resizable: true,
                      sortable: false,
                      filter: false,
                      suppressRowClickSelection: true,
                      suppressMenu: true,
                      suppressMovable: true
                    }}
                    columnDefinitions={[
                      {
                        headerName: 'Items',
                        flex: 1,
                        minWidth: 200,
                        cellRenderer: ({ data }) => (
                          <div className='product-item-wrapper'>
                            <img src={data.image_url || ProductImg} alt="Product" />
                            <span className='product-item'>{data.title || '---'}</span>
                          </div>
                        )
                      },
                      { headerName: 'SKU', field: 'msku', flex: 1, minWidth: 100 },
                      { headerName: 'ASIN', field: 'asin', flex: 1, minWidth: 100 },
                      { headerName: 'Quantity', field: 'quantity', flex: 1, minWidth: 100 }
                    ]}
                    rowHeight={64}
                    headerHeight={36}
                    containerHeight={tableHeight}
                    masterDetail={true}
                    detailRowAutoHeight={true}
                    getRowNodeId={({ __rowId }) => __rowId}
                    className="sku-table"
                  />
                </div>
                <footer>
                  <Button 
                    text={confirmingPlacementOption ? "Confirming..." : "Confirm Placement Option"} 
                    className="primary"
                    onClick={() => {
                      dispatch(ConfirmPlacementOption({ 
                        workOrderId, 
                        placementOptionId: selectedPlacement?.placementOptionId,
                        amazonInboundPlanId: inboundPlanId
                      })).then(({ payload }) => {
                        if (payload?.success) {
                           dispatch(GetWarehouseShipments({ workOrderId }));
                        }
                      });
                    }}
                    disabled={confirmingPlacementOption || !selectedPlacement?.placementOptionId}
                  />
                </footer>
              </Spin>
            </div>
          </>
        ) : (
          <ContactInformationWrapper>            {/* Top Section: Contact Information & Ship Date */}
            {isPackNow && (
              <>
                <div style={{ display: 'flex', gap: '16px', marginBottom: '24px', flexWrap: 'nowrap', alignItems: 'flex-end' }}>
                  <div style={{ width: '220px' }}>
                    <Input
                      label="Name"
                      important
                      placeholder="Enter"
                      style={{ height: '32px', fontSize: '12px' }}
                      value={contactDetails.name}
                      onChange={({ target }) => setContactDetails(prev => ({ ...prev, name: target.value }))}
                    />
                  </div>
                  <div style={{ width: '220px' }}>
                    <Input
                      label="Phone Number"
                      important
                      placeholder="Enter"
                      style={{ height: '32px', fontSize: '12px' }}
                      value={contactDetails.phone}
                      onChange={({ target }) => setContactDetails(prev => ({ ...prev, phone: target.value }))}
                    />
                  </div>
                  <div style={{ width: '220px' }}>
                    <Input
                      label="Email Address"
                      important
                      placeholder="Enter"
                      style={{ height: '32px', fontSize: '12px' }}
                      value={contactDetails.email}
                      onChange={({ target }) => setContactDetails(prev => ({ ...prev, email: target.value }))}
                    />
                  </div>
                  <div style={{ width: '220px' }}>
                    <InputWrapper marginBottom="16px">
                      <Form.Group>
                        <label style={{ fontSize: '12px', color: '#7E8A90', fontWeight: 400, marginBottom: '4px', display: 'block', lineHeight: '16px' }}>
                          Ready to Ship Date
                          <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </label>
                        <DatePicker
                          style={{ width: '100%', height: '32px', fontSize: '12px' }}
                          className='new-date-picker-ready-to-ship'
                          value={contactDetails.shipDate ? moment(contactDetails.shipDate) : null}
                          onChange={(date, dateStr) => confirmReset(() => setContactDetails(prev => ({ ...prev, shipDate: dateStr })))}
                          disabledDate={(current) => current && !current.isAfter(moment(), 'day')}
                        />
                      </Form.Group>
                    </InputWrapper>
                  </div>
                </div>
              </>
            )}

            {/* Middle Section: Shipment Cards Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: shipments?.length > 1 ? 'repeat(2, 1fr)' : '1fr', gap: '24px' }}>
              {shipments?.map((shipment, index) => {
                const { 
                  amazon_shipment_id, 
                  amazon_shipment_confirmation_id, 
                  amazon_warehouse_id, 
                  shipment_items_info = [], 
                  boxes_info = [],
                  destination_address_line_1 = '',
                  destination_city = '',
                  destination_state_or_province_code = '',
                  destination_postal_code = '',
                  destination_country_code = '',
                  amazon_reference_id
                } = shipment;

                const detail = transportationDetails[index] || {};
                const shipmentMode = getShipmentMode(detail);
                const isLtl = shipmentMode === 'LTL';
                const isSp = shipmentMode === 'SP';
                const expectedShippingMode = isLtl ? 'FREIGHT_LTL' : 'GROUND_SMALL_PARCEL';
                
                const formattedAddress = `${destination_address_line_1} ${destination_city} ${destination_state_or_province_code} ${destination_postal_code} ${destination_country_code}`.trim().replace(/\s+/g, ' ');

                // Group options
                const shipmentPartneredOptions = (() => {
                  const opts = partneredOptions?.filter(opt => opt.shipmentId === amazon_shipment_id) || [];
                  const grouped = opts.reduce((acc, opt) => {
                    const cName = opt.carrier.name;
                    if (!acc[cName]) acc[cName] = [];
                    acc[cName].push(opt);
                    return acc;
                  }, {});
                  return Object.entries(grouped).map(([label, opts]) => {
                    const amounts = opts.map(o => o?.quote?.cost?.amount);
                    const priceLabel = amounts.every(a => a === amounts[0]) ? `($${amounts[0]})` : `($${Math.min(...amounts)} - $${Math.max(...amounts)})`;
                    const sorted = [...opts].sort((a, b) => new Date(a.carrierAppointment?.startTime) - new Date(b.carrierAppointment?.startTime));
                    return {
                      label: `${label} \n${priceLabel}`,
                      value: isSp ? sorted[0]?.transportationOptionId : sorted.map(o => ({ label: `${dayjs(o?.carrierAppointment?.startTime).format("MMMM D, YYYY")} \n($${o?.quote?.cost?.amount})`, value: o?.transportationOptionId })),
                      minPrice: Math.min(...amounts),
                      transportationOptionIds: opts.map(o => o?.transportationOptionId)
                    };
                  }).sort((a, b) => a.minPrice - b.minPrice).map(({ minPrice, ...rest }) => rest);
                })();

                const shipmentNonPartneredOptions = (() => {
                  const seen = new Set();
                  return (nonPartneredOptions?.filter(opt => opt.shipmentId === amazon_shipment_id && opt.shippingMode === expectedShippingMode) || [])
                    .filter(o => { if (seen.has(o.carrier.name)) return false; seen.add(o.carrier.name); return true; })
                    .map(o => ({ value: o.transportationOptionId, label: o.carrier.name }));
                })();
                const shipmentDeliveryWindowOptions = (deliveryWindowOptions[amazon_shipment_id] || []).map(dw => ({ value: dw.deliveryWindowOptionId, label: `${dayjs(dw.startDate).format("MMMM D, YYYY")} - ${dayjs(dw.endDate).format("MMMM D, YYYY")}` }));

                const shipmentRowIndex = shipmentsData.findIndex(sd => sd.amazon_shipment_id === shipment.amazon_shipment_id);
                const sData = shipmentsData[shipmentRowIndex] || {};
                const freightInfo = sData.freightInfo || { value: '', class: 'estimate' };
                const pallets = sData.pallets || [];

                return (
                  <div key={amazon_shipment_id} style={{ background: '#fff', border: '1px solid #ECEFF1', borderRadius: '8px', overflow: 'hidden' }}>
                    <div style={{ padding: '12px 16px', background: '#F8FAFB', borderBottom: '1px solid #ECEFF1' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <h6 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#1D2129' }}>{amazon_shipment_confirmation_id || amazon_shipment_id}</h6>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ background: '#8E44AD', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 700, color: '#fff' }}>{shipmentMode}</span>
                          {isPackNow && hasNoOptions && (
                            <Radio.Group size="small" value={shipmentMode} onChange={({ target }) => handleShipmentModeChange(index, target.value)}>
                              <Radio.Button value="SP">SPD</Radio.Button>
                              <Radio.Button value="LTL">LTL</Radio.Button>
                            </Radio.Group>
                          )}
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', fontSize: '11px', color: '#86909C' }}>
                        <span>Location: <strong style={{ color: '#1D2129' }}>{amazon_warehouse_id}</strong></span>
                        <Divider type="vertical" style={{ margin: 0, height: '12px', background: '#D9D9D9' }} />
                        <span>SKUs: <strong style={{ color: '#1D2129' }}>{shipment_items_info.length}</strong></span>
                        <Divider type="vertical" style={{ margin: 0, height: '12px', background: '#D9D9D9' }} />
                        <span>Ref ID: <strong style={{ color: '#1D2129' }}>{amazon_reference_id || '---'}</strong></span>
                        {!isPackNow && (
                          <>
                            <Divider type="vertical" style={{ margin: 0, height: '12px', background: '#D9D9D9' }} />
                            <span>Ship Date: <strong style={{ color: '#1D2129' }}>{contactDetails.shipDate || '---'}</strong></span>
                          </>
                        )}
                        <Divider type="vertical" style={{ margin: 0, height: '12px', background: '#D9D9D9' }} />
                        <span>Units: <strong style={{ color: '#1D2129' }}>{shipment_items_info.reduce((s, i) => s + Number(i.quantity || 0), 0)}</strong></span>
                        <Divider type="vertical" style={{ margin: 0, height: '12px', background: '#D9D9D9' }} />
                        <span>Boxes Count: <strong style={{ color: '#1D2129' }}>{boxes_info.length}</strong></span>
                      </div>
                    </div>

                    <div style={{ padding: '16px' }}>
                      {isPackNow && isLtl && (
                        <div style={{ marginBottom: '16px' }}>
                          <p style={{ fontSize: '13px', fontWeight: 700, color: '#1D2129', marginBottom: '8px' }}>Freight Information</p>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '12px' }}>
                            <Input 
                              label="Total Value" 
                              placeholder="Enter"
                              value={freightInfo.value} 
                              onChange={({ target }) => handleFreightInfoUpdate(shipmentRowIndex, 'value', target.value)} 
                            />
                            <ReactSelect 
                              label="Freight Class" 
                              important
                              placeholder="Select"
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              options={[{ value: 'estimate', label: `Estimate` }, ...sellerFreightClassValues.slice(1)]} 
                              value={freightInfo.class === 'estimate' ? { value: 'estimate', label: 'Estimate' } : sellerFreightClassValues.find(o => o.value === Number(freightInfo.class))}
                              onChange={(e) => handleFreightInfoUpdate(shipmentRowIndex, 'class', e?.value)} 
                            />
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                            <p style={{ margin: 0, fontSize: '13px', fontWeight: 700, color: '#1D2129' }}>
                              Pallets <span style={{ color: 'red' }}>*</span>
                            </p>
                            <Button text="Add New" size="small" onClick={() => addPalletRow(shipmentRowIndex)} />
                          </div>
                          <div style={{ overflowX: 'auto' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 40px', gap: '4px', marginBottom: '2px', borderBottom: '1px solid #F2F3F5', paddingBottom: '2px' }}>
                              {['Length (in)', 'Width (in)', 'Height (in)*', 'Weight (lb)*', 'Stackable*', 'No. of Pallets*', 'Actions'].map(h => (
                                <span key={h} style={{ fontSize: '10px', color: '#86909C', fontWeight: 500 }}>{h}</span>
                              ))}
                            </div>
                            {pallets.map((p, pIdx) => (
                              <div key={pIdx} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 40px', gap: '4px', alignItems: 'center', marginBottom: '4px' }}>
                                <Input value={40} disabled style={{ background: '#F8FAFB', height: '32px', fontSize: '12px' }} />
                                <Input value={48} disabled style={{ background: '#F8FAFB', height: '32px', fontSize: '12px' }} />
                                <Input placeholder="Enter" value={p.height} style={{ height: '32px', fontSize: '12px' }} onChange={({ target }) => handlePalletUpdate(shipmentRowIndex, pIdx, 'height', target.value)} />
                                <Input placeholder="Enter" value={p.weight} style={{ height: '32px', fontSize: '12px' }} onChange={({ target }) => handlePalletUpdate(shipmentRowIndex, pIdx, 'weight', target.value)} />
                                <ReactSelect 
                                  placeholder="Select"
                                  menuPlacement="auto"
                                  menuPortalTarget={document.body}
                                  options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]} 
                                  value={p.stackable ? { label: p.stackable, value: p.stackable } : null} 
                                  styles={{ control: (b) => ({ ...b, minHeight: '32px', height: '32px' }), valueContainer: (b) => ({ ...b, height: '32px', padding: '0 8px' }) }}
                                  onChange={(e) => handlePalletUpdate(shipmentRowIndex, pIdx, 'stackable', e?.value)} 
                                />
                                <Input placeholder="Enter" value={p.noOfPallets} style={{ height: '32px', fontSize: '12px' }} onChange={({ target }) => handlePalletUpdate(shipmentRowIndex, pIdx, 'noOfPallets', target.value)} />
                                <div style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }} onClick={() => removePalletRow(shipmentRowIndex, pIdx, p.id)}>
                                  <div style={{ width: '24px', height: '24px', border: '1px solid #FFCCC7', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FF4D4F', background: '#FFF1F0', fontSize: '14px' }}>×</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div style={{ fontSize: '11px', marginBottom: '8px', color: '#1D2129' }}>
                        <span>Ship To: <strong>{amazon_warehouse_id} {formattedAddress}</strong></span>
                      </div>

                      {(!hasNoOptions) && (
                        <div style={{ borderTop: '1px solid #F0F2F5', paddingTop: '8px' }}>
                          <p style={{ fontSize: '13px', fontWeight: 700, color: '#1D2129', marginBottom: '6px' }}>
                            Carrier Information <span style={{ color: 'red' }}>*</span>
                          </p>
                          <Radio.Group 
                            value={detail.carrierType} 
                            onChange={({ target }) => handleCarrierTypeChange(index, target.value)} 
                            style={{ width: '100%', marginBottom: '8px' }}
                          >
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Radio value="partnered" disabled={!shipmentPartneredOptions.length} />
                                  <ReactSelect
                                    placeholder="Partnered Carrier"
                                    options={shipmentPartneredOptions}
                                    isDisabled={detail.carrierType !== 'partnered'}
                                    menuPlacement="auto"
                                    menuPortalTarget={document.body}
                                    styles={{ container: (b) => ({ ...b, flex: 1 }), control: (b) => ({ ...b, minHeight: '32px' }) }}
                                    value={detail.carrierType !== 'partnered' ? null : (isSp ? shipmentPartneredOptions.find(o => o.value === detail.transportationOptionId?.partnered) : (partneredCarrierValue[index] || shipmentPartneredOptions.find(o => o.value?.some(so => so.value === detail.transportationOptionId?.partnered))))}
                                  onChange={(e) => {
                                    if (isSp) {
                                      handleCarrierTypeChange(index, 'partnered');
                                      setTransportationDetails(prev => {
                                        const clone = cloneDeep(prev);
                                        clone[index].transportationOptionId.partnered = e.value;
                                        return clone;
                                      });
                                    } else {
                                      const matched = shipmentPartneredOptions.find(c => c.label.trim() === e.label.trim());
                                      setPartneredCarrierValue(pv => { const c = [...pv]; c[index] = e; return c; });
                                      setPickupDate(pv => { const c = [...pv]; c[index] = matched?.value[0] || null; return c; });
                                      setSelectedPCOptions(pv => { const c = [...pv]; c[index] = e.value; return c; });
                                      setTransportationDetails(prev => {
                                        const c = cloneDeep(prev);
                                        c[index].carrierType = 'partnered';
                                        c[index].transportationOptionId.partnered = matched?.transportationOptionIds[0];
                                        return c;
                                      });
                                    }
                                  }}
                                />
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Radio value="non-partnered" />
                                <ReactSelect
                                  placeholder="Non-Partnered Carrier"
                                  options={shipmentNonPartneredOptions}
                                  isDisabled={detail.carrierType !== 'non-partnered'}
                                  menuPlacement="auto"
                                  menuPortalTarget={document.body}
                                  styles={{ container: (b) => ({ ...b, flex: 1 }), control: (b) => ({ ...b, minHeight: '32px' }) }}
                                  value={shipmentNonPartneredOptions.find(o => o.value === detail.transportationOptionId?.nonPartnered)}
                                  onChange={(e) => {
                                    handleCarrierTypeChange(index, 'non-partnered');
                                    setTransportationDetails(prev => {
                                      const c = cloneDeep(prev);
                                      c[index].transportationOptionId.nonPartnered = e.value;
                                      return c;
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </Radio.Group>



                          <div style={{ display: 'grid', gridTemplateColumns: (!isSp || detail.carrierType === 'non-partnered') ? '1fr 1fr' : '1fr', gap: '12px', alignItems: 'flex-end', marginBottom: '8px' }}>
                            {detail.carrierType === 'partnered' && !isSp && (
                              <div>
                                <ReactSelect
                                  label="Pickup Dates"
                                  options={selectedPCOptions[index]}
                                  menuPlacement="auto"
                                  menuPortalTarget={document.body}
                                  styles={{ control: (b) => ({ ...b, minHeight: '32px' }) }}
                                  value={pickupDate[index] || selectedPCOptions[index]?.find(o => o.value === detail.transportationOptionId?.partnered)}
                                  onChange={(e) => {
                                    setPickupDate(pv => { const c = [...pv]; c[index] = e; return c; });
                                    setTransportationDetails(prev => {
                                      const c = cloneDeep(prev);
                                      c[index].transportationOptionId.partnered = e.value;
                                      return c;
                                    });
                                  }}
                                />
                              </div>
                            )}
                            {detail.carrierType === 'non-partnered' && !isSp && (
                              <div style={{ marginBottom: '4px' }}>
                                <Input 
                                  label="Pro Number" 
                                  important 
                                  placeholder="Enter Pro Number"
                                  style={{ height: '32px', fontSize: '12px', width: '100%' }}
                                  value={detail.proNumber} 
                                  onChange={({ target }) => {
                                    setTransportationDetails(prev => {
                                      const c = cloneDeep(prev);
                                      c[index].proNumber = target.value;
                                      return c;
                                    });
                                  }} 
                                />
                              </div>
                            )}

                            {(!isSp || detail.carrierType === 'non-partnered') && (
                              <div style={{ marginBottom: '4px' }}>
                                <p style={{ fontSize: '11px', color: '#4E5969', fontWeight: 600, marginBottom: '2px' }}>
                                  Select Delivery Window <span style={{ color: 'red' }}>*</span>
                                </p>
                                <ReactSelect
                                  options={shipmentDeliveryWindowOptions}
                                  placeholder="(December 9, 2024) - (December 10, 2024)"
                                  menuPlacement="auto"
                                  menuPortalTarget={document.body}
                                  loading={generatingDeliveryWindowOptionsLoading || listingDeliveryWindowOptions}
                                  isDisabled={
                                    !detail.carrierType ||
                                    (isSp ? !detail.transportationOptionId?.nonPartnered : false)
                                  }
                                  styles={{
                                    control: (b) => ({ ...b, minHeight: '32px', height: '32px' }),
                                    valueContainer: (b) => ({ ...b, height: '32px', padding: '0 8px' }),
                                    indicatorsContainer: (b) => ({ ...b, height: '32px' })
                                  }}
                                  value={shipmentDeliveryWindowOptions.find(o => o.value === detail.deliveryWindowOptionId)}
                                  onChange={(e) => {
                                    setTransportationDetails(prev => {
                                      const c = cloneDeep(prev);
                                      c[index].deliveryWindowOptionId = e.value;
                                      return c;
                                    });
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Bottom Section: Fees Details & Confirm Button */}
            <div style={{ marginTop: '48px', display: 'flex', alignItems: 'flex-end', width: '100%' }}>
              <div style={{ background: '#fff', border: '1px solid #ECEFF1', borderRadius: '8px', padding: '20px', width: '380px', textAlign: 'left' }}>
                <p style={{ fontSize: '16px', fontWeight: 700, color: '#1D2129', marginBottom: '12px', textAlign: 'left' }}>Fees Details</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#4E5969', marginBottom: '8px', textAlign: 'left' }}>
                  <span style={{ textAlign: 'left' }}>Placement Fees:</span>
                  <span style={{ fontWeight: 600, color: '#1D2129', textAlign: 'right' }}>${(selectedPlacement?.fees?.reduce((s, f) => s + (f.value?.amount || 0), 0) || placementFee || 0).toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#4E5969', marginBottom: '12px', textAlign: 'left' }}>
                  <span style={{ textAlign: 'left' }}>Estimate Shipping Fees:</span>
                  <span style={{ fontWeight: 600, color: '#1D2129', textAlign: 'right' }}>${(() => {
                    let total = 0;
                    transportationDetails.forEach((d) => {
                      if (d.carrierType === 'partnered') {
                        const opt = partneredOptions?.find(o => o.transportationOptionId === d.transportationOptionId?.partnered);
                        total += (opt?.quote?.cost?.amount || 0);
                      }
                    });
                    return total.toFixed(2);
                  })()}</span>
                </div>
                <div style={{ borderTop: '1px solid #F2F3F5', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: 'left' }}>
                  <span style={{ fontSize: '15px', fontWeight: 700, color: '#1D2129', textAlign: 'left' }}>Total Estimated Fees:</span>
                  <span style={{ fontSize: '17px', fontWeight: 800, color: '#1D2129', textAlign: 'right' }}>${(
                    (selectedPlacement?.fees?.reduce((s, f) => s + (f.value?.amount || 0), 0) || placementFee || 0) +
                    transportationDetails.reduce((total, d) => {
                      if (d.carrierType === 'partnered') {
                        const opt = partneredOptions?.find(o => o.transportationOptionId === d.transportationOptionId?.partnered);
                        return total + (opt?.quote?.cost?.amount || 0);
                      }
                      return total;
                    }, 0)
                  ).toFixed(2)}</span>
                </div>
              </div>
              <div style={{ marginBottom: '8px', marginLeft: 'auto', display: 'flex', gap: '12px', alignItems: 'center' }}>
                {isPackNow && (
                  <Button
                    text="Cancel Plan"
                    className="danger mb-0"
                    minWidth="90px"
                    disabled={cancelingInboundPlan}
                    onClick={onCancelPlan}
                  />
                )}
                <Button
                  text={(confirmingTransportationOption || isConfirmingTransportation) ? "Confirming..." : "Confirm Shipping"}
                  className="primary"
                  style={{ padding: '12px 64px', fontSize: '16px', borderRadius: '8px', height: '48px' }}
                  disabled={hasNoOptions || getConfirmBtnDisabledStatus() || isConfirmingTransportation}
                  onClick={handleConfirmTransportationOptions}
                />
              </div>
            </div>

            {isPackNow && hasNoOptions && (
              <div style={{ position: 'fixed', bottom: '32px', right: '32px' }}>
                <Button
                  text={isLoadingOptions ? 'Generating...' : 'Submit'}
                  className="primary"
                  style={{ padding: '12px 64px', fontSize: '16px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                  disabled={isLoadingOptions || !contactDetails.shipDate || (hasAnyLtlShipment && (!contactDetails.name || !contactDetails.phone || !contactDetails.email)) || !isPalletsComplete()}
                  onClick={handleGenerateTransportationOptions}
                />
              </div>
            )}
          </ContactInformationWrapper>
        )}
      </StepThreeWrapper>

      <Modal
        saveText="Yes"
        className="Delete-modal-wrapper-item"
        onClose={() => {
          setIsResetModalVisible(false);
          setResetCallback(null);
        }}
        onSave={handleResetConfirm}
        closeText="Cancel"
        centerAlign
        size="small"
        open={isResetModalVisible}
        removeIcon
      >
        <AlertModalStyleWrapper>
          <div className='alert-modal-wrapper'>
            <img src={AlterIcon1} alt='AlertIcon' title='AlertIcon' />
            <Typography fontSize={24} component="h3" marginTop={3}>Want to edit?</Typography>
            <p>Are you sure you want to edit the information? you will lose the Carrier information</p>
          </div>
        </AlertModalStyleWrapper>
      </Modal>
      <PackScanModal
        open={packScanVisible}
        onClose={() => setPackScanVisible(false)}
        workOrderId={workOrderId}
        forcedPageType="PackageLabel_Thermal_NonPCP"
      />
    </Spin>
  );
};

export default StepThree;
